export default __webpack_public_path__ + "static/media/dmsans-regular-webfont.ad7ea213.woff2";